<template>
  <div class="footer">
    <a-button class="footer__button--cancel" @click="handleCancel">{{ cancelText }}</a-button>
    <a-button id="add-confirmation-button" type="primary" @click="handleOk">
      {{ confirmText }}
    </a-button>
  </div>
</template>

<script>
import { defineComponent } from "vue";

export default defineComponent({
  props: {
    cancelText: {
      required: true,
      type: String,
    },
    confirmText: {
      required: true,
      type: String,
    },
  },
  setup(_, { emit }) {
    const handleCancel = () => {
      emit("onCancel");
    };
    const handleOk = () => {
      emit("onConfirm");
    };
    return {
      handleCancel,
      handleOk,
    };
  },
});
</script>

<style lang="sass" scoped>
.footer
    display: flex
    align-items: center
    justify-content: flex-end
    padding: 10px 16px
    border-top: $border-normal
    position: absolute
    width: 100%
    bottom: 0
    left: 0
    background-color: $white
    &__button--cancel
        margin-right: 12px
</style>
